export default __webpack_public_path__ + "static/media/flop-hit_0001_thumb.8fcbafca.jpg";